import React from 'react';
import { Button } from '@naf/button';
import { ButtonContainer, Container, ContentContainer, IconContainer, StyledAction, StyledActionLink, StyledError, StyledInfo, StyledNeutral, StyledTitle, StyledWarning, TextContainer } from './Styles';
export let NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType["ACTION"] = "Action";
  NotificationType["ERROR"] = "Error";
  NotificationType["WARNING"] = "Warning";
  NotificationType["INFO"] = "Info";
  NotificationType["NEUTRAL"] = "Neutral";
  return NotificationType;
}({});
export const NotificationIcon = ({
  variant
}) => {
  switch (variant) {
    case NotificationType.NEUTRAL:
      return /*#__PURE__*/React.createElement(StyledNeutral, null);
    case NotificationType.ACTION:
      return /*#__PURE__*/React.createElement(StyledAction, null);
    case NotificationType.ERROR:
      return /*#__PURE__*/React.createElement(StyledError, null);
    case NotificationType.WARNING:
      return /*#__PURE__*/React.createElement(StyledWarning, null);
    case NotificationType.INFO:
    default:
      return /*#__PURE__*/React.createElement(StyledInfo, null);
  }
};
export const Notification = ({
  title,
  subTitle,
  button,
  variant = NotificationType.INFO
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    variant: variant
  }, /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(NotificationIcon, {
    variant: variant
  })), /*#__PURE__*/React.createElement(TextContainer, null, title && /*#__PURE__*/React.createElement(StyledTitle, {
    tag: "span"
  }, title), subTitle && /*#__PURE__*/React.createElement(StyledTitle, {
    tag: "span"
  }, subTitle))), /*#__PURE__*/React.createElement(ButtonContainer, null, variant === NotificationType.ACTION ? /*#__PURE__*/React.createElement(Button, {
    className: "actionButton",
    onClick: button?.onClick,
    variant: "signature",
    size: "small",
    type: "button"
  }, button?.text) : /*#__PURE__*/React.createElement(StyledActionLink, {
    onClick: button?.onClick
  }, button?.text))));
};
//# sourceMappingURL=Notification.js.map